/**
 * Detect HTML/script tags in input
 * @param {string} value - Text to inspect
 * @returns {boolean} True when HTML tags are present
 */
export const containsHtmlTags = (value) => {
  const safeValue = value ?? "";
  if (!safeValue || typeof safeValue !== "string") return false;
  return /<[^>]*>/i.test(safeValue) ?? false;
};

/**
 * Strip HTML tags from plain text input
 * @param {string} value - Text to sanitize
 * @returns {string} Text without HTML tags
 */
export const stripHtmlTags = (value) => {
  const safeValue = value ?? "";
  if (!safeValue || typeof safeValue !== "string") return "";
  return safeValue?.replace?.(/<[^>]*>/gi, "") ?? "";
};

/**
 * Sanitize plain-text input by stripping HTML tags
 * @param {string} value - Raw input value
 * @returns {string} Sanitized value
 */
export const sanitizePlainTextInput = (value) => {
  const trimmedStart = value?.trimStart?.() ?? "";
  return stripHtmlTags(trimmedStart ?? "") ?? "";
};
